module.exports = __webpack_public_path__ + "static/media/flria shot 12.461775df.webp";